import React, { useEffect } from "react";
import { Segmented } from "antd";

const InvoiceStatusButtons = ({ invoices, selectedStatus, setSelectedStatus }) => {

    // ✅ Zähle offene Rechnungen für jeden Status
    const countInvoicesByStatus = (status) => {
        if (!invoices || invoices.length === 0) return 0;

        return invoices.filter((inv) => {
            switch (status) {
                case "notCompleted":
                    return inv.legal_review !== "approved" ||
                        inv.content_review !== "approved" ||
                        inv.accounting !== "approved" ||
                        inv.payment_approval !== "approved";
                case "legalReview":
                    return inv.legal_review !== "approved";
                case "contentReview":
                    return inv.content_review !== "approved";
                case "accounting":
                    return inv.accounting !== "approved";
                case "payment":
                    return inv.payment_approval !== "approved";
                case "completed":
                    return inv.legal_review === "approved" &&
                        inv.content_review === "approved" &&
                        inv.accounting === "approved" &&
                        inv.payment_approval === "approved";
                default:
                    return true;
            }
        }).length;
    };

    useEffect(() => {
        console.log("🚀 InvoiceStatusButtons geladen!");
        console.log("🔄 [useEffect] Status geändert auf:", selectedStatus);
    }, [selectedStatus]);

    return (
        <div style={{ marginBottom: "20px", textAlign: "center" }}>
            <Segmented
                block
                value={selectedStatus}
                onChange={(value) => setSelectedStatus(value)}
                size="large"
                options={[
                    {
                        label: (
                            <div style={{ textAlign: "center" }}>
                                <div style={{ fontSize: "22px", fontWeight: "bold" }}>
                                    {countInvoicesByStatus("notCompleted")}
                                </div>
                                <div style={{ fontSize: "14px" }}>Nicht Abgeschlossen</div>
                            </div>
                        ),
                        value: "notCompleted"
                    },
                    {
                        label: (
                            <div style={{ textAlign: "center" }}>
                                <div style={{ fontSize: "22px", fontWeight: "bold" }}>
                                    {countInvoicesByStatus("legalReview")}
                                </div>
                                <div style={{ fontSize: "14px" }}>Rechtlich prüfen</div>
                            </div>
                        ),
                        value: "legalReview"
                    },
                    {
                        label: (
                            <div style={{ textAlign: "center" }}>
                                <div style={{ fontSize: "22px", fontWeight: "bold" }}>
                                    {countInvoicesByStatus("contentReview")}
                                </div>
                                <div style={{ fontSize: "14px" }}>Inhaltlich prüfen</div>
                            </div>
                        ),
                        value: "contentReview"
                    },
                    {
                        label: (
                            <div style={{ textAlign: "center" }}>
                                <div style={{ fontSize: "22px", fontWeight: "bold" }}>
                                    {countInvoicesByStatus("accounting")}
                                </div>
                                <div style={{ fontSize: "14px" }}>Kontieren</div>
                            </div>
                        ),
                        value: "accounting"
                    },
                    {
                        label: (
                            <div style={{ textAlign: "center" }}>
                                <div style={{ fontSize: "22px", fontWeight: "bold" }}>
                                    {countInvoicesByStatus("payment")}
                                </div>
                                <div style={{ fontSize: "14px" }}>Zahlen</div>
                            </div>
                        ),
                        value: "payment"
                    },
                    {
                        label: (
                            <div style={{ textAlign: "center" }}>
                                <div style={{ fontSize: "22px", fontWeight: "bold" }}>
                                    {countInvoicesByStatus("completed")}
                                </div>
                                <div style={{ fontSize: "14px" }}>Abgeschlossen</div>
                            </div>
                        ),
                        value: "completed"
                    }
                ]}
                style={{ width: "100%", background: "#f0f2f5" }}
            />
        </div>
    );
};

export default InvoiceStatusButtons;